import Lottie from "lottie-react";

import Astronaute from './Animation - 1736308161175.json';

const style = {
    animation: 'spawn .9s 1.75s 1 ease-out forwards',
    transform: 'translate(calc(-50% + -800px), calc(-50% + 400px)) scale(2.5)',
    position: 'absolute',
    left: '50%',
    top: '50%',
};

function LootiePresentation() {
    return (
        <div style={style} className="lottie_footer">
            <Lottie animationData={Astronaute} />
        </div>
    )

}

export default LootiePresentation;
